var _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHallFlag = function SvgHallFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 384,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9CEC6",
    stroke: "#000",
    d: "M0 383.164h107v-35H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5C1",
    stroke: "#000",
    d: "M0 363.164h107v-15H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1C1C1",
    stroke: "#000",
    d: "M26 8h7v340h-7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 7,
    r: 6,
    fill: "#C1C1C1",
    stroke: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBE24",
    stroke: "#000",
    d: "M64.188 16.662C60.224 11.018 37.23 13.798 26 13.015v47.222c5.68-1.437 21.092-5.9 32.5 3.043 5.688 4.459 27.348-1.099 32.5-1.622V18.286c-7.134.587-22.85 4.019-26.812-1.625Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#451D07",
    d: "M68.163 43.056q1.666 2.087.699 4.538-.969 2.451-3.844 3.216a5.7 5.7 0 0 1-2.805.029q-1.43-.337-2.345-1.275-3.315 1.388-6.232-.136-2.915-1.524-3.504-4.953-1.451-.331-2.466-1.306T46.2 40.711q-.721-2.38 1.148-4.46t4.338-1.807l2.89.328q.468-1.431 1.612-2.558a6.7 6.7 0 0 1 2.704-1.626l-.615-2.03q-.153-.508.1-.934.254-.426.795-.57.543-.144.997.094.455.238.608.745l.71 2.342q1.672.02 2.95.672 1.278.651 2.482 2.102l2.417-.642q.542-.144.996.094.456.237.609.745.155.508-.1.933-.253.426-.795.57l-2.167.576a6.1 6.1 0 0 1-.015 2.999 5.9 5.9 0 0 1-1.436 2.617zm-10.05 3.684a11.6 11.6 0 0 1-.434-2.1 10.6 10.6 0 0 1-.023-2.081 8.2 8.2 0 0 1-1.879 1.153q-1.05.47-2.158.68.46 1.522 1.665 2.151 1.203.63 2.828.197m-5.023-5.582q1.333-.355 2.26-.939t2.267-1.952l-5.592-.623q-1.35-.147-2.056.568t-.387 1.77q.307 1.014 1.157 1.294t2.35-.118m10.982 6.529q1.042-.277 1.48-1.132.44-.855-.118-1.508l-3.858-4.711a12.3 12.3 0 0 0-.473 2.825q-.06 1.365.248 2.38.39 1.29 1.077 1.845.685.555 1.644.3m.125-9.398q.3-.501.354-1.212a3.8 3.8 0 0 0-.158-1.413 3.09 3.09 0 0 0-1.514-1.876q-1.135-.626-2.427-.282-.75.2-1.346.61a3.1 3.1 0 0 0-.924.963l3.676.542z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1C1C1",
    stroke: "#000",
    d: "M78 44h7v304h-7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 43,
    r: 6,
    fill: "#C1C1C1",
    stroke: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    stroke: "#000",
    d: "M115.6 52.591c-3.902-5.535-26.543-2.808-37.6-3.577V95.33c5.594-1.41 20.767-5.788 32 2.984 5.6 4.373 26.927-1.078 32-1.59v-42.54c-7.024.577-22.498 3.943-26.4-1.592Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hall-flag_svg__a)",
    d: "M110.448 85.358a5.5 5.5 0 0 1-.8-1c-.572-.837-1.53-2.805-1.533-4.968-2.022 1.1-4.355 1.314-5.428 1.27a6.3 6.3 0 0 1-1.205-.118q.675 3.06 3.382 4.468 2.627 1.365 5.584.348m7.259-8.96a5.8 5.8 0 0 0 1.199-2.324 5.95 5.95 0 0 0 .014-2.943l2.139-.565c.165-.038.32-.108.454-.204.135-.096.248-.218.331-.356.082-.138.133-.29.15-.448a1.1 1.1 0 0 0-.053-.467 1.1 1.1 0 0 0-.218-.424 1.2 1.2 0 0 0-.38-.308 1.32 1.32 0 0 0-.984-.091l-2.386.63q-1.188-1.424-2.45-2.063-1.261-.64-2.911-.658l-.7-2.3a1.1 1.1 0 0 0-.219-.423 1.2 1.2 0 0 0-.381-.308 1.333 1.333 0 0 0-.984-.091 1.3 1.3 0 0 0-.454.203 1.2 1.2 0 0 0-.33.355 1.1 1.1 0 0 0-.099.916l.606 1.992a6.7 6.7 0 0 0-2.668 1.597 6.4 6.4 0 0 0-1.398 2.003l7.137.82zm-15.041-5.557c-1.242.004-2.431.468-3.307 1.29-.875.82-1.364 1.933-1.359 3.09s.503 2.265 1.385 3.08c.881.816 2.074 1.271 3.317 1.267h.027c1.09.048 3.74-.232 5.627-1.654l3.747-5.99zm6.692 7.642 3.682-5.886 5.752 6.873a4.1 4.1 0 0 1 .453 3.313c-.327 1.117-1.116 2.067-2.195 2.642a5 5 0 0 1-3.557.421c-1.198-.304-2.218-1.04-2.835-2.044l-.013-.023c-.583-.846-1.63-3.085-1.287-5.296"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hall-flag_svg__a",
    x1: 136.413,
    x2: 84.909,
    y1: 74.663,
    y2: 75.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F29C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#F6DB2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#F4A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E85A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#B93483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#502B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2136"
  })))));
};
export default SvgHallFlag;